export default ".table tr td {\n  border: 1px solid #ddd;\n}\n\n.border-right-none {\n  border-right: none !important;\n}"